import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LinearGradient from '@hfe/max-linear-gradient';
import './index.scss';
import { BizLineDesc } from '../../types/rewardRecords';
import Icon from '@max/leez-icon';
import Button from '@hfe/max-button';
import { formatTimestamp } from '../../utils/time';
import { fenToYuan } from '../../utils/price';
import { parseFreeOrderCardExtra } from '../../utils/rewardRecords';
import { getPriceFontFamily } from '../../utils/style';
const priceFontFamily = getPriceFontFamily();
function FreeOrderReceivedCard(props) {
    const { rewardItem, feConfig } = props;
    const { styleConfig, haveCardUnusedConfig } = feConfig ?? {};
    const freeOrderInfo = parseFreeOrderCardExtra(rewardItem) ?? {};
    const endTimeStamp = formatTimestamp(freeOrderInfo?.useEndTime, 'chinese-without-year');
    const yuanPrice = fenToYuan(freeOrderInfo.amount);
    // 城市信息从 selectedCardGroups[0] 取
    const cityInfo = freeOrderInfo?.selectedCardGroups?.[0];
    const displayCityName = cityInfo?.cityName ?? '';
    const canBindBizLineNames = (freeOrderInfo?.canBindBizLines ?? []).map(line => BizLineDesc[line] ?? String(line));
    const titleText = haveCardUnusedConfig?.compactTitleText ?? '获得城市住行玩免单卡';
    return <View className="free-order-received-card__container" style={{
        backgroundColor: styleConfig?.backgroundColor
    }}>
      <LinearGradient className="free-order-received-card__background" colors={[styleConfig?.cardStartColor, styleConfig?.cardEndColor]}/>
      <View className="free-order-received-card__wrapper">
        
        <View className="free-order-received-card__left">
          <View className="free-order-received-card__badge">
            <Text className="free-order-received-card__badge-text">最高可减</Text>
          </View>
          <View className="free-order-received-card__amount-wrapper">
            <Text className="free-order-received-card__amount-prefix" style={{
        fontFamily: priceFontFamily
    }}>
              ¥
            </Text>
            <Text className="free-order-received-card__amount-content" numberOfLines={1} style={{
        fontFamily: priceFontFamily
    }}>
              {yuanPrice}
            </Text>
          </View>
          <Text x-if={!!endTimeStamp} className="free-order-received-card__expire-text">
            {endTimeStamp}到期
          </Text>
        </View>
        
        <View className="free-order-received-card__right">
          <View className="free-order-received-card__title-wrapper">
            <Text className="free-order-received-card__title" numberOfLines={1}>
              {titleText}
            </Text>
          </View>
          <View x-if={canBindBizLineNames.length > 0} className="free-order-received-card__biz-line-wrapper">
            <Text className="free-order-received-card__biz-line-text" numberOfLines={1}>
              可核销{displayCityName}-{canBindBizLineNames.join('、')}等订单
            </Text>
            <Button className="free-order-received-card__biz-line-icon-btn" onPress={props.onOpenBindingRule}>
              <Icon name="wenhao" className="free-order-received-card__biz-line-icon"/>
            </Button>
          </View>
        </View>
      </View>
    </View>;
}
export default memo(FreeOrderReceivedCard);
